import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const submitQuote = (data) => axios.post(`${API}/quotes`, data);

export const verifyPasscode = (passcode) =>
  axios.post(`${API}/admin/verify`, { passcode });

export const fetchQuotes = (passcode) =>
  axios.get(`${API}/admin/quotes`, { headers: { "x-admin-passcode": passcode } });

export const updateQuoteStatus = (id, status, passcode) =>
  axios.patch(
    `${API}/admin/quotes/${id}`,
    { status },
    { headers: { "x-admin-passcode": passcode } }
  );

export const deleteQuote = (id, passcode) =>
  axios.delete(`${API}/admin/quotes/${id}`, {
    headers: { "x-admin-passcode": passcode },
  });

export const SERVICES = [
  "Manufacturing of Cuplock Scaffolding",
  "Rental of Cuplock Scaffolding",
  "Erection & Dismantling",
  "Scaffolding Inspection Services",
  "Scaffolding GA Drawing Services",
  "Hydrojetting Services",
];
